<script>
  import LicenseTypeChip from '@/components/LicenseTypeChip/LicenseTypeChip.vue';

  export default {
    name: 'ProductInformation',

    components: { LicenseTypeChip },

    props: {
      product: {
        type: Object,
        required: true,
      },

      isPublicMenu: Boolean,
    },
  };
</script>

<template>
  <div>
    <h3 class="ll-mt-3 ll-mb-2">{{ $t('brand_menu.productInformation') }}</h3>
    <dl class="ll-grid ll-grid-cols-2" :class="$style['gap-6']">
      <template v-if="product.license">
        <dt class="color-ice-900 font-weight-medium">{{ $t('common.license') }}</dt>
        <dd>
          <LicenseTypeChip :license="product.license" :title="product.license.number" />
          <a
            v-if="!isPublicMenu"
            :for="product.license.id"
            :class="[
              'text-small text-break-all',
              { [$style['private-license']]: !product.license.public || !product.license.url },
            ]"
            :href="product.license.url"
            rel="noopener"
            target="_blank"
          >
            {{ product.license.number }}
          </a>
        </dd>
      </template>
      <dt class="color-ice-900 font-weight-medium">{{ $t('common.category') }}</dt>
      <dd class="show-empty">{{ product.category.name }}</dd>
      <dt class="color-ice-900 font-weight-medium">{{ $t('common.subcategory') }}</dt>
      <dd class="show-empty">{{ product.subCategory.name }}</dd>
      <dt class="color-ice-900 font-weight-medium">{{ $t('common.classification') }}</dt>
      <dd>{{ product.strainClassification }}</dd>
      <template v-if="product.strainNames">
        <dt class="color-ice-900 font-weight-medium">{{ $t('common.strains') }}</dt>
        <dd>{{ product.strainNames }}</dd>
      </template>

      <template v-for="item in product.productDataItems" :key="`item-id-${item.id}`">
        <dt class="color-ice-900 font-weight-medium">
          {{ item.name }}
        </dt>
        <dd>
          {{ item.value }}
        </dd>
      </template>

      <template v-if="product.displayAvailableInventory">
        <dt class="color-ice-900 font-weight-medium">{{ $t('common.quantityAvailable') }}</dt>
        <dd>{{ product.displayAvailableInventory }}</dd>
      </template>

      <template v-if="product.displayGrowType">
        <dt class="color-ice-900 font-weight-medium">{{ $t('common.growOperation') }}</dt>
        <dd>{{ product.displayGrowType }}</dd>
      </template>
    </dl>
  </div>
</template>

<style module lang="scss">
  .gap-6 {
    gap: space(1);
  }

  .private-license {
    color: var(--color-ice-700);
    cursor: default;
    font-size: typo('body', 'size');

    &:hover {
      text-decoration: none;
    }
  }
</style>
